import script from "./ScrollPagerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollPagerView.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollPagerView.vue?vue&type=style&index=0&id=24a03a5a&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a03a5a"]])

export default __exports__